module.exports = __webpack_public_path__ + "static/media/home-presentation-image-04.f9b297e5.jpg";